module.exports = __webpack_public_path__ + "img/body-3.b864e0e8.png";